var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav"},[_c('ol',_vm._l((_vm.items),function(item,key){return _c('li',{key:key},[_c('a',{attrs:{"href":item.href}},[_vm._v(_vm._s(item.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }